module.exports = __webpack_public_path__ + "static/media/360.e1cc6da0.png";